import * as D from './deps';

export const CONTENT_URL_PREFIX = 'https://content-images.p-cdn.com/';

export function getPreloadedBrowseData(data = {}) {
  return data[D.Constants.Api.ApiEndpoints.PLS_GET_DIRECTORY] || null;
}

export function getFullImagePath(imagePath) {
  const defaultValue = null;

  if (imagePath) {
    if (imagePath.startsWith('https')) {
      return imagePath;
    }
    return CONTENT_URL_PREFIX + imagePath;
  }

  return defaultValue;
}
